/*
This is intended to be a setting than a direct translation
because ES will have different sets of categories and different slugs or ids
*/
import en from './en'
import es from './es'

module.exports = {
  en, es
}



// WEBPACK FOOTER //
// ./assets/js/components/navigations/helpers/navItems/index.js